// PagePurchaseOrder Component

import React from 'react'

import app from '../../../app.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import List from '../../../../components/List/List.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import DialogMail from '../../../common/dialog/dialog_email/dialog_email.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import DialogSpreadsheetExport from '../../../common/dialog/dialog_spreadsheet_export/dialog_spreadsheet_export'
import PurchaseOrderItem from '../../purchaseorder/purchaseorder_item/purchaseorder_item.jsx'
import DialogPurchaseOrderAdd from '../../dialog/dialog_purchaseorder_add/dialog_purchaseorder_add.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import ExpenseForm from '../../form/expense_form/expense_form.jsx'
import ExpenseUtil from '../../../lib/expenseutil.js'
import EmailUtil from '../../../lib/emailutil.js'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Acl from '../../../lib/acl.jsx'
import {
  canDeletePurchaseOrder,
  getDownloadUrl
} from './pagePurchaseOrderUtilities'
import routes from '../../../../shared/routes.js'
import { ExpensesIcon } from '../../../common/layout/menu_icons/expenses.jsx'

import { getVatRateSelectOptionsFromArray } from '../../../lib/vat_rates_select_options.js'
import { getVatRatesForCountry } from '../../../../shared/util/vat'

class PagePurchaseOrder extends PageBase {
  constructor (props) {
    super(props, 'purchaseorders', 'expenses', 'purchaseorders')

    this.state = {
      isLoading: true,
      dataDate: null,
      purchaseorder: null,
      bShowDialog: false
    }

    this.data = {
      purchaseorders: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      sort: 'invoiceNo',
      sortAsc: true,
      pageNo: 1,
      pageState: {
        type: 'grid',
        sort: 'invoiceNo',
        sortAsc: true,
        filter: null
      },
      team: app.getTeam()
    }

    this._references = {
      dialogPurchaseOrderAdd: React.createRef(),
      expenseForm: React.createRef(),
      refHeaderPo: React.createRef(),
      purchaseOrderSettingDialog: React.createRef(),
      confirmDelete: React.createRef(),
      refdialogMail: React.createRef(),
      exportDialog: React.createRef()
    }

    this._setFABButtonState(true, false)
    this._initRealTimeVariables()
    this._bUnMounted = false
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
    this._getData(false)
    this._initEvents()

    /* Load quickbook options for expense */
    ExpenseUtil.initQuickbookItems()
  }

  componentWillUnmount () {
    this._bUnMounted = true

    this._releaseEvents()
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
  }

  renderContent () {
    const { purchaseorder } = this.state
    const vatLevels =
      this.data.team && this.data.team.profile
        ? getVatRateSelectOptionsFromArray(
          getVatRatesForCountry(this.data.team.profile.country)
        )
        : []
    const suggestions =
      purchaseorder && purchaseorder.contact
        ? EmailUtil.getEmailSuggestions(purchaseorder.contact)
        : []

    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderSettingsDialog()}
        <DialogPurchaseOrderAdd
          ref={this._references.dialogPurchaseOrderAdd}
          getProjects={this._getProjects.bind(this)}
          supplierSearch={this._onSearchContact.bind(this, false)}
          onSubmit={this._onSubmitAdd.bind(this)}
        />
        <ExpenseForm
          ref={this._references.expenseForm}
          onSubmit={this._onSubmitExpense.bind(this)}
          contactsearch={this._onSearchContact.bind(this, true)}
          /* eslint react/jsx-handler-names: "off" */
          onValidateInvoiceNo={ExpenseUtil.validateInvoiceNo}
          showError={this.showError.bind(this)}
          getProjects={ExpenseUtil.getProjects}
          getContactBudgetItems={ExpenseUtil.getContactBudgetItems}
          /* eslint react/jsx-handler-names: "off" */
          onAddBudgetExpense={ExpenseUtil.onAddBudgetExpense}
          /* eslint react/jsx-handler-names: "off" */
          onSelectBudgetExpense={ExpenseUtil.onSelectBudgetExpense}
          /* eslint react/jsx-handler-names: "off" */
          onSearchBudgetItem={ExpenseUtil.getProjectBudgetItems}
          onClose={this._onCloseForm.bind(this)}
          /* eslint react/jsx-handler-names: "off" */
          onCreateContact={ExpenseUtil.onCreateContact}
          attachment={this.data.team.integration.isAttached}
          validateExpenseTotalWithPO={ExpenseUtil.validateExpenseTotalWithPO}
          vatLevels={vatLevels}
          defaultVat={app.getDefaultVat()}
          showVat={app.isVatSupportedInCountry(app.teamCountry)}
          isQuickbookConnected={app.isQuickbookConnected()}
          getQuickbookItems={ExpenseUtil.getQuickbookItems}
          reloadQuickbookItems={ExpenseUtil.reloadQuickbookItems}
        />
        <DialogMail
          ref={this._references.refdialogMail}
          onSubmit={this._onSubmitMail.bind(this)}
          mailSuggestions={suggestions}
          showMultiAttachments
          showLanguage={app.teamCountry === 'NL' || app.teamCountry === 'DE'}
        />
        {this._renderExportDialog()}
      </div>
    )
  }

  _handleDocumentKeyDown = evt => {
    if (
      this.ignoreAutoSearch ||
      (this._references.expenseForm.current &&
        this._references.expenseForm.current.isActive()) ||
      (this._references.dialogPurchaseOrderAdd.current &&
        this._references.dialogPurchaseOrderAdd.current.isActive())
    ) {
      return
    }

    if (this._references.refHeaderPo.current && !this.state.bShowDialog) {
      const keyCode = evt.keyCode || 0

      let bSearch = true
      if (
        keyCode === 13 ||
        keyCode === 9 ||
        keyCode === 27 ||
        keyCode === 17 ||
        keyCode === 224
      ) {
        bSearch = false
      } else if (evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
        bSearch = false
      }

      if (keyCode === 27) {
        this._references.refHeaderPo.current.onEscKeyDown()
      } else if (
        bSearch &&
        this._references.refHeaderPo.current &&
        this._references.refHeaderPo.current.canShowSearch()
      ) {
        this._references.refHeaderPo.current.showSearch()
      }
    }
  }

  getContentClassname () {
    return this.data.pageState.type === 'grid' ? 'alt' : null
  }

  /* Event handlers */
  onAdd () {
    if (this._references.dialogPurchaseOrderAdd.current) {
      this._references.dialogPurchaseOrderAdd.current.show()
    }
  }

  _onSubmitAdd (purOrderObj) {
    if (purOrderObj) {
      purOrderObj.createdById = app.loggedInId

      app
        .service('/api/purchaseorder')
        .create(purOrderObj)
        .then(createRes => {
          if (createRes) {
            if (this._references.dialogPurchaseOrderAdd.current) {
              this._references.dialogPurchaseOrderAdd.current.hide()
            }

            app.changePage('purchaseorder-view', createRes.id)
          }
        })
        .catch(createErr => {
          app.debug('PagePurchaseOrder: _onSubmitAdd createErr', createErr)
        })
    }
  }

  _onSubmitMail (mailObj) {
    this.setState({ isLoading: true })

    EmailUtil.sendPurchaseOrdeMail(mailObj, this.state.purchaseorder)
      .then(_result => {
        if (this._references.refdialogMail.current) {
          this._references.refdialogMail.current.hide()

          if (this._references.purchaseOrderSettingDialog.current) {
            this._references.purchaseOrderSettingDialog.current.hide()
          }
        }

        this.setState({ isLoading: false, bShowDialog: false })
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _onSubmitMail err', err)
      })
  }

  _onGridItemClick (purchaseorder) {
    if (purchaseorder) {
      app.changePage('purchaseorder-view', purchaseorder.id)
    }
  }

  _onGridItemSettingClick (purchaseorder) {
    const status = Util.getTranslatedStatus(purchaseorder.status)
    if (purchaseorder) {
      this.setState({ purchaseorder: purchaseorder })

      if (this._references.purchaseOrderSettingDialog.current) {
        this._references.purchaseOrderSettingDialog.current.show(
          purchaseorder.contact ? purchaseorder.contact.company : '',
          purchaseorder.invoiceNo,
          null,
          IntlUtil.convertMessage(status).toUpperCase()
        )
      }
    }
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }

    this.setState({ bShowDialog: false })
  }

  _onEdit (purchaseorder, e) {
    e.preventDefault()

    if (purchaseorder && purchaseorder.id) {
      app.changePage('purchaseorder-view', purchaseorder.id)
    }
  }

  _onClose (purchaseorder, e) {
    e.preventDefault()

    if (this._references.purchaseOrderSettingDialog.current) {
      this._references.purchaseOrderSettingDialog.current.hide()
    }

    app
      .service('/api/purchaseorder')
      .patch(this.state.purchaseorder.id, { status: 'Closed' })
      .then(_closeRes => {})
      .catch(closeErr => {
        app.debug('PagePurchaseOrder close closeErr', closeErr)
      })
  }

  _onReopen (purchaseorder, e) {
    e.preventDefault()

    if (this._references.purchaseOrderSettingDialog.current) {
      this._references.purchaseOrderSettingDialog.current.hide()
    }

    app
      .service('/api/purchaseorder')
      .patch(this.state.purchaseorder.id, { status: 'Open' })
      .then(_openRes => {})
      .catch(openErr => {
        app.debug('PagePurchaseOrder open openErr', openErr)
      })
  }

  _onSendMail (purchaseorder, e) {
    e.preventDefault()

    const params = { query: {} }
    app
      .service('/api/purchaseorder/mail')
      .get(purchaseorder.id, params)
      .then(result => {
        if (result && this._references.refdialogMail.current) {
          this.setState({ bShowDialog: true })
          this._references.refdialogMail.current.show(result)
        }
      })
      .catch(err => {
        app.debug('PagePurchaseOrderView: _onSendMail err', err)
      })
  }

  _onAddPurchaseInvoice (purchaseorder, e) {
    e.preventDefault()

    if (this._references.purchaseOrderSettingDialog.current) {
      this._references.purchaseOrderSettingDialog.current.hide()
    }

    ExpenseUtil.createExpenseDataFromPO(purchaseorder, (expense, items) => {
      if (this._references.expenseForm.current) {
        this._references.expenseForm.current.show(expense, false, items)
      }
    })
  }

  _onDelete (e) {
    e.preventDefault()

    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    if (!this.state.purchaseorder.id) {
      return false
    }

    e.preventDefault()
    app
      .service('/api/purchaseorder')
      .remove(this.state.purchaseorder.id)
      .then(_deleteRes => {
        if (this._references.purchaseOrderSettingDialog.current) {
          this._references.purchaseOrderSettingDialog.current.hide()
        }
      })
      .catch(deleteErr => {
        app.debug('PagePurchaseOrder delete err', deleteErr)
      })
  }

  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onClickExport (exportFileType, event) {
    event.preventDefault()

    const params = {
      query: {
        pageIdent: this._pageIdent,
        pageState: this.data.pageState,
        bUpdatePageState: false,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        expense: {
          $client: {
            subObjects: {
              contact: ['company', 'image', 'imageUrl'],
              items: []
            }
          }
        }
      }
    }
    app.service('/api/purchase-order/export').timeout = 10000
    app
      .service('/api/purchase-order/export')
      .create({ exportFileType }, params)
      .then(downloadPath => app.redirect(downloadPath))
      .catch(err => {
        app.logger.error(
          `Attempt to export Purchase Order data to [.${exportFileType}] failed!`,
          err
        )
      })
  }

  _onExport () {
    if (this._references.exportDialog.current) {
      this._references.exportDialog.current.show()
    }
  }

  _onFilter (filter) {
    this.data.pageState.filter = filter

    if (filter.contentType !== this.data.pageState.type) {
      this.data.pageState.type = filter.contentType
      this.forceUpdate()
      this._updatePageState(this.data.pageState)
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  _onCloseFilter () {
    this.data.pageState.filter.status = ''
    this.data.pageState.filter.supplier = null
    this.data.pageState.filter.datefilter = null
    this.data.pageState.filter.project = null
    this.data.pageState.filter.keyword = null
    this._reloadData()
  }

  _getData (bReload) {
    this._setDataLoading()

    const sort = this.data.pageState.sort
    const sortAsc = this.data.pageState.sortAsc ? 1 : -1
    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        pageIdent: this._pageIdent,
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        purchaseorder: {
          $limit: 20,
          $skip: skip,
          $sort: {},
          $client: {
            subObjects: {
              contact: ['company', 'contactPersons'],
              project: ['title', 'projectNumber'],
              items: []
            }
          }
        }
      }
    }
    params.query.purchaseorder.$sort[sort] = sortAsc

    app
      .service('/api/page/page-purchase-order')
      .find(params)
      .then(pagePurchaseorderRes => {
        this._onPageDataRecieved(pagePurchaseorderRes.pageData)

        this.data.purchaseorders =
          this.data.pageNo > 1
            ? this.data.purchaseorders.concat(
              pagePurchaseorderRes.purchaseorders
            )
            : pagePurchaseorderRes.purchaseorders
        this.data.total = pagePurchaseorderRes.totalPurchaseorders
        this.data.countLoaded =
          params.query.purchaseorder.$limit * this.data.pageNo
        this.data.canPaginate = !(this.data.countLoaded > this.data.total)
        this._onDataReceived(null)
      })
      .catch(err => {
        app.debug('PagePurchaseOrder: _getDataPurchaseOrder err', err)
        this._onDataReceived(err)
      })
  }

  _getDataPurchaseOrder (callback) {
    app.debug('PagePurchaseOrder: _getDataPurchaseOrder [start]')
    const sort = this.data.pageState.sort
    const sortAsc = this.data.pageState.sortAsc ? 1 : -1
    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        $limit: 20,
        $skip: skip,
        $sort: {},
        $client: {
          subObjects: {
            contact: ['company'],
            project: ['title']
          }
        }
      }
    }

    params.query.$sort[sort] = sortAsc

    // Process Filters
    const filter = this.data.pageState.filter
    if (filter) {
      if (filter.supplier) {
        params.query.contactId = filter.supplier.value
      }

      if (filter.project) {
        params.query.projectId = filter.project.value
      }

      if (filter.datefilter) {
        params.query.invoiceDate = {}
        if (filter.datefilter.value.from) {
          params.query.invoiceDate.$gte = new Date(filter.datefilter.value.from)
        }

        if (filter.datefilter.value.to) {
          params.query.invoiceDate.$lte = new Date(filter.datefilter.value.to)
        }
      }

      if (filter.status) {
        params.query.status = filter.status
      }
    }

    app
      .service('/api/purchaseorder')
      .find(params)
      .then(result => {
        this.data.purchaseorders =
          this.data.pageNo > 1
            ? this.data.purchaseorders.concat(result.data)
            : result.data
        this.data.total = result.total
        this.data.countLoaded = params.query.$limit * this.data.pageNo
        this.data.canPaginate = !(this.data.countLoaded > this.data.total)
        callback(null)
      })
      .catch(err => {
        app.debug('PagePurchaseOrder: _getDataPurchaseOrder err', err)
        callback(err)
      })
  }

  _reloadData () {
    this._getData(true)
  }

  _onUserStateRecieved (userState) {
    const pageState = this._getPageUserState(userState)
    if (pageState) {
      this.data.pageState = {
        sort: pageState.sort || 'invoiceNo',
        sortAsc: pageState.sortAsc !== undefined ? pageState.sortAsc : true,
        type: pageState.type || 'grid',
        filter: pageState.filter || null
      }
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PagePurchaseOrder: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
    } else {
      app.debug('PagePurchaseOrder: _onDataReceived [done]')

      if (this.data.purchaseorders && this.data.purchaseorders.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _getListCloumns () {
    const projectSetting = app.projectSetting

    return [
      {
        label: 'expense.list.orderBySupplier',
        identifier: 'company',
        width: '20%',
        sort: false,
        filterType: 'autocomplete',
        type: 'link',
        field: 'contact'
      },
      {
        label: projectSetting.useProjectNo
          ? 'expense.list.orderByProjectNumber'
          : 'expense.list.orderByProject',
        identifier: projectSetting.useProjectNo ? 'projectNumber' : 'title',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text',
        field: 'project'
      },
      {
        label: 'expense.list.orderByPoNumber',
        identifier: 'invoiceNo',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'expense.list.orderByStatus',
        identifier: 'status',
        width: '15%',
        sort: true,
        filterType: 'autocomplete',
        type: 'status'
      },
      {
        label: 'expense.list.orderByTotal',
        identifier: 'total',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'expense.list.orderByRemainingPO',
        identifier: 'remainingPO',
        width: '10%',
        sort: false,
        type: 'custom',
        customType: 'price'
      }
    ]
  }

  _getSortOptions () {
    return [
      // disabled until we fix the sort function
      // { label: 'expense.list.orderBySupplier', value: 'company' },
      { label: 'expense.list.orderByProject', value: 'title' },
      { label: 'expense.list.orderByPoNumber', value: 'invoiceNo' },
      { label: 'expense.list.orderByStatus', value: 'status' },
      { label: 'expense.list.orderByTotal', value: 'total' }
    ]
  }

  _getProjects (contactId, callback) {
    if (contactId) {
      const params = {
        query: {
          contactId: contactId
        }
      }

      app
        .service('/api/project/budgetitemsupplier')
        .find(params)
        .then(result => {
          const projectIds = result.data.map(obj => obj.projectId)
          if (projectIds.length > 0) {
            const projParams = {
              query: {
                _id: projectIds
              }
            }

            app
              .service('/api/project')
              .find(projParams)
              .then(projectRes => {
                if (projectRes) {
                  const options = projectRes.data.map(obj => ({
                    label: obj.title,
                    value: obj.id
                  }))
                  /* eslint standard/no-callback-literal: "off" */
                  callback(options)
                } else {
                  /* eslint standard/no-callback-literal: "off" */
                  callback([])
                }
              })
              .catch(err => {
                app.debug('PagePurchaseOrder: _getProjects err', err)
                /* eslint standard/no-callback-literal: "off" */
                callback([])
              })
          } else {
            /* eslint standard/no-callback-literal: "off" */
            callback([])
          }
        })
    } else {
      /* eslint standard/no-callback-literal: "off" */
      callback([])
    }
  }

  _onSearchContact (bGetPoClients, keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          company: { $regex: pattern, $options: 'i' },
          $select: ['_id', 'company', 'rateMarkup', 'archived'],
          $limit: 25,
          $client: {
            getPurchaseOrderClients: bGetPoClients
          }
        }
      }

      app.debug('PagePurchaseOrder: _onSearchContact ', keyword)
      app
        .service('/api/expense/supplier')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(obj => ({
              label: obj.company,
              value: obj.id,
              rateMarkup: obj.rateMarkup,
              bArchived: obj.archived
            }))
            /* eslint standard/no-callback-literal: "off" */
            callback(options)
          } else {
            /* eslint standard/no-callback-literal: "off" */
            callback([])
          }
        })
        .catch(err => {
          app.debug('PagePurchaseOrder: _onSearchContact ERROR ', err)
          /* eslint standard/no-callback-literal: "off" */
          callback([])
        })
    } else {
      /* eslint standard/no-callback-literal: "off" */
      callback([])
    }
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  _onSubmitExpense (
    expenseObj,
    expenseId,
    items,
    deletedItemIds,
    fileObj,
    bDeleteFile,
    closePoIds,
    newContactData,
    callback
  ) {
    expenseObj.createdById = app.loggedInId
    const bSendQuickbook = expenseObj.bSendQuickbook

    if (expenseId) {
      ExpenseUtil.updateExpense(
        expenseObj,
        expenseId,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        updateErr => {
          if (updateErr) {
            app.debug('PagePurchaseOrder updateErr', updateErr)
            if (updateErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (updateErr.code >= 501 || updateErr.code <= 510) {
              this.showError(`expense.list.errorMsg${updateErr.code}`)
            } else {
              this.showError('expense.list.errorUpdateMsg')
            }
            callback(updateErr)
          } else {
            this._onAfterSave(false, bSendQuickbook, null, callback)
          }
        }
      )
    } else {
      ExpenseUtil.createExpense(
        expenseObj,
        items,
        deletedItemIds,
        fileObj,
        bDeleteFile,
        closePoIds,
        newContactData,
        (createErr, createRes) => {
          if (createErr) {
            app.debug('PagePurchaseOrder createErr', createErr)
            if (createErr.message === 'Invoice number already exists') {
              this.showError('expense.list.errorInvoiceNoAlreadyExists')
            } else if (createErr.code >= 501 || createErr.code <= 510) {
              this.showError(`expense.list.errorMsg${createErr.code}`)
            } else {
              this.showError('expense.list.errorCreateMsg')
            }
            callback(createErr)
          } else {
            this._onAfterSave(true, bSendQuickbook, createRes.expense, callback)
          }
        }
      )
    }
  }

  _onAfterSave (bCreateExpense, bSendQuickbook, expense, callback) {
    // If Quickbooks is not connected, close the form immediately
    // If expense is already sent to Quickbooks, close the form immediately
    if (!app.isQuickbookConnected() || !bSendQuickbook) {
      callback(null)

      if (this._references.expenseForm.current) {
        this._references.expenseForm.current.hide(false)
      }

      this._reloadData()
    } else {
      // If Quickbooks is connected, open form in edit mode,
      // and wait until the Quickbooks response comes
      if (bCreateExpense) {
        if (expense && expense.id) {
          ExpenseUtil.getExpenseDetails(expense.id, (expenseObj, items) => {
            if (expenseObj) {
              if (this._references.expenseForm.current) {
                this._references.expenseForm.current.show(
                  expenseObj,
                  true,
                  items
                )
              }
            }
          })
        }
      }
    }
  }

  _onCloseForm () {
    if (this._references.expenseForm.current) {
      this._references.expenseForm.current.hide()
    }
  }

  /* Private functions */
  _onRenderList (purchaseorder, column, idx) {
    const value = purchaseorder[column.identifier]
    const width = column.width
    const showtooltip = purchaseorder[column.showtooltip]
    const estimatedMargin = purchaseorder[column.estimatedMargin]

    if (column.customType === 'price') {
      return (
        <ReportPriceCell
          price={value}
          width={width}
          showtooltip={showtooltip}
          key={idx}
          estimatedMargin={estimatedMargin}
        />
      )
    }

    return ''
  }

  _onRenderGrid (purchaseorder) {
    const pdfFileName = Util.getPdfFileName(
      'purchaseorder',
      purchaseorder.invoiceNo,
      purchaseorder.status
    )
    return (
      <PurchaseOrderItem
        purchaseOrder={purchaseorder}
        key={purchaseorder.id}
        showProjectNumber={app.projectSetting.useProjectNo}
        onView={this._onGridItemClick.bind(this)}
        onSetting={this._onGridItemSettingClick.bind(this)}
        downloadUrl={`${routes.PURCHASEORDER_PREVIEW}/${app.getTeamId()}/${
          app.loggedInId
        }/${purchaseorder.id}/${pdfFileName}`}
      />
    )
  }

  _renderExportDialog () {
    return (
      <DialogSpreadsheetExport
        ref={this._references.exportDialog}
        noExpense={this.data.total}
        onExportExcel={this._onClickExport.bind(this, 'xlsx')}
        onExportCsv={this._onClickExport.bind(this, 'csv')}
        i18nTitleKey='purchaseOrder.export.title'
        i18nSubTitleKey='purchaseOrder.export.subTitle'
      />
    )
  }

  _renderGridOrList () {
    if (this.state.isLoading || !this.data?.purchaseorders?.length) {
      return null
    }

    let bShowLoader = false
    if (this.data?.purchaseorders?.length < this.data.total) {
      bShowLoader = true
    }

    if (this.data.pageState.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.purchaseorders}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            actionIcon='common-action-setting'
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            showLoader={bShowLoader}
            onSettings={this._onGridItemSettingClick.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.purchaseorders}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _renderSettingsDialog () {
    const { purchaseorder, loading } = this.state

    if (loading) {
      return ''
    }

    // If there is no purchase order we render a dummy dialog so that the ref is available,
    // with the upside that we don't need to check if the purchase order exists in the rest of the render.
    if (!purchaseorder) {
      return <DialogSetting ref={this._references.purchaseOrderSettingDialog} />
    }

    const { status } = purchaseorder
    const canDelete = canDeletePurchaseOrder({
      purchaseOrder: purchaseorder,
      acl: Acl
    })
    const downloadUrl = getDownloadUrl({
      purchaseOrder: purchaseorder,
      teamId: app.getTeamId(),
      userId: app.loggedInId
    })
    const colAddClass =
      status === 'Open'
        ? 'actionboard-col2 alert-col2'
        : 'actionboard-col2 alert-col2 disabled'
    const colDelClass = canDelete
      ? 'actionboard-col2 alert-col2 confirm alt'
      : 'actionboard-col2 alert-col2 disabled'
    const colReopenClass =
      status !== 'Closed'
        ? 'actionboard-col2 alert-col2 disabled'
        : 'actionboard-col2 alert-col2'

    return (
      <DialogSetting
        ref={this._references.purchaseOrderSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
        className='alt'
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onEdit.bind(this, purchaseorder)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionEdit' />
              </span>
            </div>
          </div>
          <div className={colDelClass}>
            <div
              className='action-btn'
              onClick={canDelete ? this._onDelete.bind(this) : null}
            >
              <Button
                icon='action-delete'
                className='button_dialog button_dialogdlt'
                canHover={false}
                tooltipPosition='bottom'
                tooltip={canDelete ? null : 'expense.list.tipDelete'}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionDelete' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div className={colAddClass}>
            <div
              className='action-btn'
              onClick={
                status === 'Open'
                  ? this._onAddPurchaseInvoice.bind(this, purchaseorder)
                  : null
              }
            >
              <Button
                icon='action-estimate'
                className='button_dialog button_dialogadd'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.purchaseInvoice' />
              </span>
            </div>
          </div>
          <div className={colAddClass}>
            <div
              className='action-btn'
              onClick={
                status === 'Open'
                  ? this._onClose.bind(this, purchaseorder)
                  : null
              }
            >
              <Button
                icon='action-close'
                className='button_dialog button_dialogdlt'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionMarkClosed' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <a
              className='action-btn'
              target='_blank'
              rel='noopener noreferrer'
              href={encodeURI(downloadUrl)}
            >
              <Button
                icon='action-download'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionOpenAttachment' />
              </span>
            </a>
          </div>
          <div className={colReopenClass}>
            <div
              className='action-btn'
              onClick={
                status === 'Closed'
                  ? this._onReopen.bind(this, purchaseorder)
                  : null
              }
            >
              <Button
                icon='action-retry'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionReopen' />
              </span>
            </div>
          </div>
        </div>
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onSendMail.bind(this, purchaseorder)}
            >
              <Button
                icon='header-mail'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='expense.list.actionSendMail' />
              </span>
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='expense.list.labelConfirmDelete'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _renderMessage () {
    if (!this.state.isLoading && !this.data?.purchaseorders?.length) {
      return (
        <ContentMessage
          message='expense.list.contentPurchaseMsg'
          info='expense.list.contentPurchaseInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return null
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.purchaseOrderCreated = this._eventReload.bind(
      this,
      'Purchase Order',
      'Created'
    )
    this._eventHandlers.purchaseOrderUpdated = this._eventReload.bind(
      this,
      'Purchase Order',
      'Updated'
    )
    this._eventHandlers.purchaseOrderRemoved = this._eventReload.bind(
      this,
      'Purchase Order',
      'Removed'
    )
    this._eventHandlers.purchaseOrderPatched = this._eventReload.bind(
      this,
      'Purchase Order',
      'Patched'
    )

    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.on('created', this._eventHandlers.purchaseOrderCreated)
    purchaseOrderService.on('updated', this._eventHandlers.purchaseOrderUpdated)
    purchaseOrderService.on('removed', this._eventHandlers.purchaseOrderRemoved)
    purchaseOrderService.on('patched', this._eventHandlers.purchaseOrderPatched)

    /* Init quickbook events */
    this._initQuickbookExpenseEvents()
  }

  _releaseEvents () {
    const purchaseOrderService = app.service('/api/purchaseorder')
    purchaseOrderService.off(
      'created',
      this._eventHandlers.purchaseOrderCreated
    )
    purchaseOrderService.off(
      'updated',
      this._eventHandlers.purchaseOrderUpdated
    )
    purchaseOrderService.off(
      'removed',
      this._eventHandlers.purchaseOrderRemoved
    )
    purchaseOrderService.off(
      'patched',
      this._eventHandlers.purchaseOrderPatched
    )

    this._eventHandlers.purchaseOrderService = null
    this._eventHandlers.purchaseOrderService = null
    this._eventHandlers.purchaseOrderService = null
    this._eventHandlers.purchaseOrderService = null

    /* Release quickbook events */
    this._releaseQuickbookExpenseEvents()
  }

  _eventReload (objectName, eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PagePurchaseOrder - ${objectName} - ${eventName} --`
      )
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  /* Header Functions - START */
  renderHeader () {
    const { pageState } = this.data
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const filter = pageState.filter || {}

    const filters = [
      {
        ident: 'status',
        type: 'option',
        label: 'expense.list.filterOpen',
        options: [
          { label: 'expense.list.filterAll', ident: 'All' },
          { label: 'expense.list.filterDraft', ident: 'Draft' },
          { label: 'expense.list.filterOpen', ident: 'Open' },
          { label: 'expense.list.filterClosed', ident: 'Closed' }
        ],
        isMulti: false,
        value: filter.status || '',
        defaultValue: 'Open'
      },
      {
        type: 'label',
        label: 'expense.list.poFilterPaid'
      },
      {
        ident: 'project',
        type: 'tag',
        label: 'expense.list.filterProjects',
        placeholder: 'expense.list.placeholderSearchProject',
        isMulti: false,
        value: filter.project || null
      },
      {
        type: 'label',
        label: 'expense.list.poFilterLabelFor'
      },
      {
        ident: 'supplier',
        type: 'tag',
        label: 'expense.list.filterSuppliers',
        placeholder: 'expense.list.placeholderSearchSuppliers',
        isMulti: false,
        value: filter.supplier || null
      },
      {
        ident: 'datefilter',
        type: 'date',
        label: 'expense.list.allPeriods',
        isMulti: true,
        value: filter.datefilter || null,
        dateOptions: [
          {
            ident: 'last-week',
            label: 'expense.list.filterDateWeek',
            value: {
              from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
              to: DateUtil.getUTCDateFromTime(
                lastWeekStartDate.getTime() + 1000 * 7 * 24 * 60 * 60
              )
            }
          },
          {
            ident: 'last-month',
            label: 'expense.list.filterDateMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
              to: DateUtil.getUTCDate(currYear, currMonth, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-month',
            label: 'expense.list.filterDateThisMonth',
            value: {
              from: DateUtil.getUTCDate(currYear, currMonth, 1),
              to: DateUtil.getUTCDate(currYear, currMonth + 1, 0, 23, 59, 59)
            }
          },
          {
            ident: 'this-year',
            label: 'expense.list.filterDateYear',
            value: {
              from: DateUtil.getUTCDate(currYear, 0, 1),
              to: DateUtil.getUTCDate(currYear, 11, 31, 23, 59, 59)
            }
          },
          {
            ident: 'last-year',
            label: 'expense.list.filterDateLastYear',
            subtitle: currYear - 1,
            value: {
              from: DateUtil.getUTCDate(currYear - 1, 0, 1),
              to: DateUtil.getUTCDate(currYear - 1, 11, 31, 23, 59, 59)
            }
          }
        ]
      }
    ]

    const actions = [
      {
        ident: 'export',
        icon: 'download-solid',
        tooltip: 'contact.list.tipExport',
        tooltipPosition: 'bottom',
        onClick: this._onExport.bind(this)
      }
    ]

    return (
      <PageHeader
        actions={actions}
        ref={this._references.refHeaderPo}
        title='expense.list.labelTitlePo'
        icon={<ExpensesIcon width={25} />}
        hasFilter
        hasSearch
        showTabs
        activeTab='purchaseorders'
        favoriteTab={this._getUserFavoriteTab('expanse') || 'expenses'}
        tabs={[
          {
            ident: 'expenses',
            title: 'expense.list.labelExpenses',
            showFavourite: true
          },
          {
            ident: 'purchaseorders',
            title: 'expense.list.labelTitlePo',
            showFavourite: true
          }
        ]}
        filters={filters}
        showGridList
        isGridActive={pageState.type === 'grid'}
        keywordSearch={filter.keyword}
        placeholderSearch='purchaseOrder.header.searchPlaceholder'
        onGridListToggle={this._onHeaderGridListToggle.bind(this)}
        onChange={this._onHeaderChangeFilter.bind(this)}
        onSearchTags={this._onHeaderSearchTags.bind(this)}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderGridListToggle (isGridActive) {
    this.data.pageState.type = isGridActive ? 'grid' : 'list'
    this._updatePageState(this.data.pageState)

    this.setState({ dataDate: new Date() })
  }

  _onHeaderChangeFilter (filter) {
    this.data.pageState.filter = filter
    this.data.pageNo = 1

    this._reloadData()
  }

  _onHeaderSearchTags (filterIdent, keyword, callback) {
    if (filterIdent === 'project') {
      this._onCommonFilterProjectSearch(keyword, false, callback)
    } else if (filterIdent === 'supplier') {
      this._onCommonFilterContactSearch(keyword, callback)
    }
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('expanse', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - END */
}

export default PagePurchaseOrder
